/* global SERVER_BASE_URL */
import {
  SEND_RESET_PASSWORD_EMAIL_REQUEST,
  SEND_RESET_PASSWORD_EMAIL_SUCCESS,
  SEND_RESET_PASSWORD_EMAIL_FAILURE,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
} from '../constants/actionTypes'

import fetch from 'isomorphic-fetch'

import processError from '../helpers/processError'

function sendResetPasswordEmailRequest() {
  return {
    type: SEND_RESET_PASSWORD_EMAIL_REQUEST,
    isSending: true,
    isFinished: false,
  }
}

function sendResetPasswordEmailSuccess() {
  return {
    type: SEND_RESET_PASSWORD_EMAIL_SUCCESS,
    isSending: false,
    isFinished: true,
  }
}

function sendResetPasswordEmailFailure(error) {
  return {
    type: SEND_RESET_PASSWORD_EMAIL_FAILURE,
    isSending: false,
    isFinished: true,
    message: error,
  }
}

export function sendResetPasswordEmail(email) {
  const url = `${SERVER_BASE_URL}/api/users/reset-password?email=${encodeURIComponent(email)}`
  const config = {
    method: 'POST',
    accept: 'application/json',
  }
  return (dispatch) => {
    dispatch(sendResetPasswordEmailRequest(email))
    return fetch(url, config)
      .then(response => {
        response.json()
          .then(res => ({ res, response }))
          .then(({ res, response }) => {
            if (!response.ok) {
              dispatch(sendResetPasswordEmailFailure(processError(res)))
              return Promise.reject(res)
            } else {
              dispatch(sendResetPasswordEmailSuccess())
            }
          }).catch(err => {
            console.log(err)
          })
      })
  }
}

function resetPasswordRequest() {
  return {
    type: RESET_PASSWORD_REQUEST,
    isResetting: true,
    didReset: false,
  }
}

function resetPasswordSuccess() {
  return {
    type: RESET_PASSWORD_SUCCESS,
    isResetting: false,
    didReset: true,
  }
}

function resetPasswordFailure(error) {
  return {
    type: RESET_PASSWORD_FAILURE,
    isResetting: false,
    message: error,
  }
}

export function resetPassword(token, password) {
  const url = `${SERVER_BASE_URL}/api/users/reset-password/${token}`
  const config = {
    method: 'POST',
    accept: 'application/json',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({
      password,
    }),
  }
  return (dispatch) => {
    dispatch(resetPasswordRequest())
    return fetch(url, config)
      .then(response => {
        response.json()
          .then(res => ({ res, response }))
          .then(({ res, response }) => {
            if (!response.ok) {
              dispatch(resetPasswordFailure(processError(res)))
              return Promise.reject(res.error)
            } else {
              dispatch(resetPasswordSuccess())
            }
          }).catch(err => {
            console.log(err)
          })
      })
  }
}
